import { render, h } from 'preact';
import { effect } from '@preact/signals';
import { Shell } from './Shell';
import { initRouter } from './lib/router';
import { hydrateFromMirror } from './lib/store';
import { initSession, session } from './lib/session';
import { applyTheme, storedTheme } from './lib/theme';

// Light / dark before anything paints (owner, 2026-09-24).
applyTheme(storedTheme());

// Tells index.html's self-heal check that the real bundle ran (2026-09-10).
(window as unknown as { __nvBooted?: boolean }).__nvBooted = true;
try { sessionStorage.removeItem('nv-reboot'); } catch { /* storage may be unavailable */ }

const root = document.getElementById('app')!;

// F-33 fix: role is no longer hardcoded. Shell drives the real app off the
// session state machine (lib/session.ts), which is fed by a real
// google.accounts.id sign-in and a real GET /api/me round-trip.
initRouter();
void hydrateFromMirror();
initSession();

// Session state changes (sign-in completing, /api/me resolving, sign-out)
// re-render the whole shell. effect() runs its body immediately once on
// creation, so this also performs the first paint — no separate initial
// render() call needed. This is startup/auth-lifecycle wiring, not a
// per-route fetch — it does not run on navigation (INV-1 is about route
// changes, not sign-in/out).
effect(() => {
  session.value;
  render(<Shell />, root);
});
